import { getCryptoCloudTariffs } from "./api/getTarrifs";

const HeaderSystem = {
  namespaced: true,

  state: {
    isOpenGiftWidget: false,
    isSubscriptionWidgetOpen: false,
    isBannerVisible: true,
    isLegendSection: false,

    // -----------------------------
    //     Тарифы CryptoCloud
    // -----------------------------
    tariffs: [],
    isTariffsLoading: false,
    tariffsError: null,
  },

  actions: {
    // ---- Получить тарифы из API ----
    async fetchCryptoCloudTariffs({ commit }) {
      commit('SET_TARIFFS_LOADING', true);
      commit('SET_TARIFFS_ERROR', null);

      try {
        const tariffs = await getCryptoCloudTariffs();
        commit('SET_TARIFFS', tariffs);
      } catch (error) {
        console.error('Ошибка загрузки тарифов CryptoCloud:', error);
        commit('SET_TARIFFS_ERROR', error.message || 'Ошибка загрузки тарифов');
      } finally {
        commit('SET_TARIFFS_LOADING', false);
      }
    },

    // ---- Обычное открытие ----
    openSubscriptionWidget({ commit }) {
      commit('SET_SUBSCRIPTION_WIDGET_OPEN', true);
      commit('SET_LEGEND_SECTION', false);
    },

    // ---- Открытие из секции легенды ----
    openSubscriptionWidgetFromLegend({ commit }) {
      commit('SET_SUBSCRIPTION_WIDGET_OPEN', true);
      commit('SET_LEGEND_SECTION', true);
    },

    closeSubscriptionWidget({ commit }) {
      commit('SET_SUBSCRIPTION_WIDGET_OPEN', false);
      commit('SET_LEGEND_SECTION', false);
      commit('SET_GIFT_SECTION', false);
    },

    toggleSubscriptionWidget({ commit, state }) {
      const newState = !state.isSubscriptionWidgetOpen;
      commit('SET_SUBSCRIPTION_WIDGET_OPEN', newState);
      if (!newState) {
        commit('SET_LEGEND_SECTION', false);
      }
    },

    // ---- Инициализация состояния баннера ----
    initBannerState({ commit, rootGetters }) {
      const isPaid = rootGetters['UserSystem/hasPaidAccess'];
      const hasBeenPaidBefore = localStorage.getItem('hasBeenPaidBefore');
      const saved = localStorage.getItem('isBannerVisible');

      if (isPaid) {
        if (!hasBeenPaidBefore) {
          localStorage.setItem('hasBeenPaidBefore', 'true');
          localStorage.setItem('isBannerVisible', 'true');
          commit('SET_BANNER_VISIBLE', true);
          return;
        }

        if (saved !== null) {
          commit('SET_BANNER_VISIBLE', saved === 'true');
        } else {
          commit('SET_BANNER_VISIBLE', false);
          localStorage.setItem('isBannerVisible', 'false');
        }
      } else {
        commit('SET_BANNER_VISIBLE', true);
      }
    },

    closeBanner({ commit, rootGetters }) {
      const isPaid = rootGetters['UserSystem/hasPaidAccess'];
      commit('SET_BANNER_VISIBLE', false);
      if (isPaid) {
        localStorage.setItem('isBannerVisible', 'false');
      }
    },

    openBanner({ commit, rootGetters }) {
      const isPaid = rootGetters['UserSystem/hasPaidAccess'];
      commit('SET_BANNER_VISIBLE', true);
      if (isPaid) {
        localStorage.setItem('isBannerVisible', 'true');
      }      
    },

    changeGiftWidget({ commit }, status){
      commit('SET_GIFT_SECTION', status);
    }
  },

  mutations: {
    SET_SUBSCRIPTION_WIDGET_OPEN(state, isOpen) {
      state.isSubscriptionWidgetOpen = isOpen;
    },
    SET_BANNER_VISIBLE(state, isVisible) {
      state.isBannerVisible = isVisible;
    },
    SET_LEGEND_SECTION(state, value) {
      state.isLegendSection = value;
    },
    SET_GIFT_SECTION(state, value) {
      state.isOpenGiftWidget = value;
    },

    // -----------------------------
    //        Мутации тарифов
    // -----------------------------
    SET_TARIFFS(state, tariffs) {
      state.tariffs = tariffs;
    },
    SET_TARIFFS_LOADING(state, isLoading) {
      state.isTariffsLoading = isLoading;
    },
    SET_TARIFFS_ERROR(state, error) {
      state.tariffsError = error;
    },
  },

  getters: {
    isSubscriptionWidgetOpen: (state) => state.isSubscriptionWidgetOpen,
    isBannerVisible: (state) => state.isBannerVisible,
    isLegendSection: (state) => state.isLegendSection,
    isGiftSection: (state) => state.isOpenGiftWidget,

    // -----------------------------
    //         Геттеры тарифов
    // -----------------------------
    tariffs: (state) => state.tariffs,
    isTariffsLoading: (state) => state.isTariffsLoading,
    tariffsError: (state) => state.tariffsError,

    // Быстрые выборки тарифов по типу:
    tariffByCode: (state) => (code) =>
      state.tariffs.find((t) => t.code === code),
    legendTariff: (state) =>
      state.tariffs.find((t) => t.code === 'legend'),
  },
};

export default HeaderSystem;